/* Lumibrace theme global JS — wired to actual Liquid markup */
(function(){
  'use strict';

  // ============== Global safety net ==============
  // Ensures the preloader is never permanently stuck on screen, even if a
  // later script throws or a slow network event never fires. Critical for
  // Instagram/Facebook in-app browsers where errors are otherwise invisible.
  function killPreloader(){
    try {
      var pre = document.getElementById('lb-preloader');
      if (pre) {
        pre.classList.add('is-hidden');
        document.documentElement.classList.remove('lb-loading');
        setTimeout(function(){ if (pre.parentNode) pre.parentNode.removeChild(pre); }, 500);
      }
    } catch(_){}
  }
  window.addEventListener('error', function(ev){
    try { console.error('[lumi][global error]', ev.message, ev.filename, ev.lineno); } catch(_){}
    killPreloader();
  });
  window.addEventListener('unhandledrejection', function(ev){
    try { console.error('[lumi][unhandled rejection]', ev.reason); } catch(_){}
    killPreloader();
  });
  // Belt & braces — bfcache restore on iOS sometimes shows the stale preloader
  window.addEventListener('pageshow', function(ev){ if (ev.persisted) killPreloader(); });
  // Max 5s no matter what
  setTimeout(killPreloader, 5000);


  // ============== iOS-safe body scroll lock ==============
  // body { overflow:hidden } does NOT lock scroll on iOS Safari / TikTok WebView.
  // We pin the body with position:fixed and restore scrollY on unlock.
  var __lockCount = 0, __savedScroll = 0;
  function lockBody(){
    if (__lockCount++ > 0) return;
    __savedScroll = window.pageYOffset || document.documentElement.scrollTop || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = (-__savedScroll) + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    b.style.overflow = 'hidden';
  }
  function unlockBody(){
    if (__lockCount > 0) __lockCount--;
    if (__lockCount > 0) return;
    var b = document.body;
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    b.style.overflow = '';
    window.scrollTo(0, __savedScroll);
  }
  window.LumiBody = { lock: lockBody, unlock: unlockBody };


  // ============== Cart count (simple) ==============
  function updateCartCount(){
    var el = document.getElementById('cart-count');
    if(!el) return;
    fetch('/cart.js', { credentials:'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(c){
        el.textContent = c.item_count;
        el.style.display = c.item_count > 0 ? '' : 'none';
      }).catch(function(){});
  }
  try { if(document.cookie && document.cookie.indexOf('cart=') !== -1) updateCartCount(); } catch(e){}

  // ============== Mobile menu ==============
  function menuEls(){
    return {
      menu: document.getElementById('mobile-menu'),
      backdrop: document.getElementById('mobile-menu-backdrop'),
      toggle: document.getElementById('menu-toggle')
    };
  }
  function openMobileMenu(){
    var e = menuEls();
    if(!e.menu) return;
    if(e.backdrop){ e.backdrop.hidden = false; }
    // force a frame so the transition runs from the closed state
    requestAnimationFrame(function(){
      e.menu.classList.add('open');
      if(e.backdrop) e.backdrop.classList.add('open');
    });
    e.menu.setAttribute('aria-hidden','false');
    if(e.toggle) e.toggle.setAttribute('aria-expanded','true');
    if(window.LumiBody) window.LumiBody.lock();
  }
  function closeMobileMenu(){
    var e = menuEls();
    if(!e.menu) return;
    e.menu.classList.remove('open');
    e.menu.setAttribute('aria-hidden','true');
    if(e.backdrop){
      e.backdrop.classList.remove('open');
      setTimeout(function(){ if(!e.menu.classList.contains('open')) e.backdrop.hidden = true; }, 320);
    }
    if(e.toggle) e.toggle.setAttribute('aria-expanded','false');
    if(window.LumiBody) window.LumiBody.unlock();
  }
  window.LumiMobileMenu = { open: openMobileMenu, close: closeMobileMenu };

  document.addEventListener('click', function(e){
    if(e.target.closest('#menu-toggle')){
      e.preventDefault();
      openMobileMenu();
      return;
    }
    if(e.target.closest('#mobile-menu-close') || e.target.closest('#mobile-menu-backdrop')){
      e.preventDefault();
      closeMobileMenu();
      return;
    }
    // Auto-close the mobile menu when the user taps any link inside it
    if(e.target.closest('#mobile-menu a')){
      closeMobileMenu();
    }
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') closeMobileMenu();
  });


  // ============== Accordions ==============
  document.addEventListener('click', function(e){
    var accBtn = e.target.closest('[data-acc-toggle]');
    if(accBtn){
      var acc = accBtn.closest('.acc');
      if(acc){ var open = acc.getAttribute('data-open') === 'true'; acc.setAttribute('data-open', open ? 'false' : 'true'); }
    }
    var faqBtn = e.target.closest('[data-faq-toggle]');
    if(faqBtn){
      var faq = faqBtn.closest('.faq');
      if(faq){
        var fopen = faq.getAttribute('data-open') === 'true';
        faq.setAttribute('data-open', fopen ? 'false' : 'true');
        faqBtn.setAttribute('aria-expanded', fopen ? 'false' : 'true');
      }
    }
  });

  // ============== Reveal-on-scroll ==============
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  }

  // ============== Header scrolled state ==============
  var hdr = document.getElementById('site-header');
  if(hdr){
    var onScroll = function(){ hdr.classList.toggle('scrolled', window.scrollY > 20); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  // ============== Smooth scroll for in-page anchors ==============
  document.addEventListener('click', function(e){
    var a = e.target.closest('a[href^="#"]');
    if(!a) return;
    var id = a.getAttribute('href');
    if(!id || id.length < 2) return;
    var t = document.querySelector(id);
    if(t){ e.preventDefault(); t.scrollIntoView({ behavior:'smooth', block:'start' }); }
  });
})();


/* Testimonials carousel */
(function(){
  function init(){
    var track = document.getElementById('testi-track');
    if(!track) return;
    var slides = track.querySelectorAll('.testi-slide');
    var dots = document.querySelectorAll('#testi-dots .carousel-dot');
    var prev = document.getElementById('testi-prev');
    var next = document.getElementById('testi-next');
    if(!slides.length) return;
    var i = 0, n = slides.length, timer = null;
    function go(to){
      i = (to + n) % n;
      slides.forEach(function(s, idx){ s.classList.toggle('active', idx === i); });
      dots.forEach(function(d, idx){ d.classList.toggle('active', idx === i); });
    }
    function start(){ stop(); timer = setInterval(function(){ go(i+1); }, 6000); }
    function stop(){ if(timer){ clearInterval(timer); timer = null; } }
    if(prev) prev.addEventListener('click', function(){ go(i-1); start(); });
    if(next) next.addEventListener('click', function(){ go(i+1); start(); });
    dots.forEach(function(d, idx){ d.addEventListener('click', function(){ go(idx); start(); }); });
    var stage = track.closest('.testi-stage') || track;
    stage.addEventListener('mouseenter', stop);
    stage.addEventListener('mouseleave', start);
    stage.addEventListener('touchstart', stop, { passive: true });
    start();
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
/* ============== Cart helpers (/cart page) ============== */
(function(){
  if(window.Cart) return;

  function jpost(url, body){
    return fetch(url, {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify(body)
    }).then(function(r){
      if(!r.ok) return r.text().then(function(t){
        var msg = '';
        try { var j = JSON.parse(t); msg = j.description || j.message || ''; } catch(_){}
        var err = new Error(msg || t || ('HTTP ' + r.status));
        err.status = r.status;
        err.shopifyMessage = msg;
        throw err;
      });
      return r.json();
    });
  }

  // Shopify's theme editor renders the storefront inside a preview iframe where
  // cart write requests (/cart/change.js, /cart/add.js) are not always allowed.
  function isDesignMode(){
    try { return !!(window.Shopify && window.Shopify.designMode); } catch(_){ return false; }
  }

  // Re-enable any button/select we disabled optimistically before the request.
  function releaseControls(){
    try {
      document.querySelectorAll('#cart-page [data-action][disabled]').forEach(function(el){ el.disabled = false; });
      document.querySelectorAll('#cart-page [data-action="change-color"]').forEach(function(el){ el.disabled = false; });
    } catch(_){}
  }
  function getCart(){
    return fetch('/cart.js', { credentials:'same-origin' }).then(function(r){ return r.json(); });
  }
  function fail(err){
    try { console.error('[cart]', err); } catch(_){}
    releaseControls();
    if(isDesignMode()){
      alert('עדכון סל אינו נתמך בתצוגה המקדימה של עורך התבנית. בדקו את הסל בחנות עצמה (/cart) — שם העדכון עובד.');
      return;
    }
    var msg = (err && err.shopifyMessage) ? String(err.shopifyMessage) : '';
    alert(msg ? ('העדכון נכשל: ' + msg) : 'העדכון נכשל. נסו שוב או רעננו את הדף.');
  }
  // Keep every customer-facing property (colors + uploaded photo URLs),
  // drop only Shopify's internal underscore keys.
  function cleanProps(line){
    var props = {};
    Object.keys(line.properties || {}).forEach(function(k){
      var v = line.properties[k];
      if(!k || k.charAt(0) === '_') return;
      if(v === null || v === '' || typeof v === 'undefined') return;
      props[k] = v;
    });
    return props;
  }

  window.Cart = {
    state: null,
    refresh: function(){
      return getCart().then(function(s){ window.Cart.state = s; return s; });
    },

    // Plain quantity change — never re-packages the line, so uploaded
    // photos and colors are always preserved.
    changeQty: function(key, qty){
      return jpost('/cart/change.js', { id: key, quantity: qty })
        .then(function(){ window.location.reload(); })
        .catch(function(err){
          // A line key can go stale (e.g. after a photo upload re-created the
          // line). Retry once addressing the line by its 1-based index.
          return getCart().then(function(cart){
            var idx = -1;
            (cart.items || []).forEach(function(it, i){ if(it.key === key) idx = i + 1; });
            if(idx < 1) throw err;
            return jpost('/cart/change.js', { line: idx, quantity: qty })
              .then(function(){ window.location.reload(); });
          }).catch(function(){ fail(err); });
        });
    },
    remove: function(key){ return this.changeQty(key, 0); },

    /**
     * Swap a cart line to a different color variant (same pack),
     * carrying over every property including uploaded photo URLs.
     *
     * Shopify's Ajax API has no "change variant" call, so this is add + remove.
     * It is wrapped in Lumi.track.edit() so it is NOT counted as a new
     * add-to-cart by GA4 (and can be filtered in the Custom Pixel).
     */
    // propsOverride lets the caller hand over already-corrected properties (e.g. the
    // cart page rewrites per-bracelet colors for the newly chosen variant). Without it
    // we fall back to copying the existing line's properties verbatim.
    changeColor: function(key, newVariantId, onError, propsOverride){
      var track = (window.Lumi && window.Lumi.track) || null;
      var run = function(){
        return getCart().then(function(cart){
          var line = cart.items.filter(function(i){ return i.key === key; })[0];
          if(!line) throw new Error('line not found');
          return jpost('/cart/add.js', {
            id: parseInt(newVariantId, 10),
            quantity: line.quantity,
            properties: propsOverride || cleanProps(line)
          })
          .then(function(){ return jpost('/cart/change.js', { id: key, quantity: 0 }); })
          .then(function(){ window.location.reload(); });
        });
      };
      return (track ? track.edit(run) : run()).catch(function(err){
        if(typeof onError === 'function') onError();
        fail(err);
      });
    }

  };
})();


